import { render, staticRenderFns } from "./BTPortalCollapse.vue?vue&type=template&id=73cbefc8&"
import script from "./BTPortalCollapse.vue?vue&type=script&lang=ts&"
export * from "./BTPortalCollapse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports